import React from 'react';
import { useNavigate } from 'react-router-dom';
import VenereAvatar from '../../shared/core/VenereAvatar';
import { VenereBox, VenereButton } from '../../shared/ui';

interface VenereMotivationalBoxProps {
  className?: string;
}

export const VenereMotivationalBox: React.FC<VenereMotivationalBoxProps> = ({
  className = '',
}) => {
  const navigate = useNavigate()

  const onContactDoctor = () => {
    navigate('/venere/consults')
  }

  return (
    <VenereBox variant='seasalt' className={`h-full lg:flex lg:flex-col lg:justify-center lg:items-center ${className}`}>
      <div className="h-full flex flex-col items-center justify-center self-center text-center gap-4 w-full">
        {/* Avatar */}
        <VenereAvatar
          variant="simple"
          size="md"
        />

        {/* Primary Text */}
        <div className="venere-text-primary">
          Sei all'inizio del tuo viaggio!
        </div>

        {/* Secondary Text */}
        <div className="venere-text-secondary max-w-md">
          In questa fase iniziale il tuo corpo sta prendendo confidenza con la terapia. È normale che i risultati non si vedano subito: le prime settimane servono ad abituarsi. Non scoraggiarti, stai costruendo le basi giuste!
        </div>

        {/* Contact Button */}
        <VenereButton
          variant="primary"
          onClick={onContactDoctor}
          className="mt-2"
        >
          Contatta il medico
        </VenereButton>
      </div>
    </VenereBox>
  );
};

export default VenereMotivationalBox; 